export default __webpack_public_path__ + "static/ru-2-ebf6ee7fe01c9d894aaf862b431feda1.svg";